/**
 * 文字情報VOクラス
 */
export class TextInfoModel {
  /**
       * [表示用]連番(商品付随文字情報連番とは異なる)
       */
  public dispNum: number = <number>0;

  /**
   * 選択状態フラグ
   */
  public selectedFlg: boolean = <boolean>false;

  /**
   * 商品付随文字情報文字列
   */
  public stringValue: string = <string>'';

  /**
   * 商品付随文字情報連番
   */
  public textKindNum: number = <number>-1;

  /**
   * 削除フラグ(画面には表示しないがVOとして保持する)
   * falseの場合は削除とみなす
   */
  public deleteFlg: boolean = <boolean>true;
}
